import { gql } from '@/__generated__/gql'

export const ContentDetailsContentAssetReferenceFragment = gql(`
  fragment ContentDetails_ContentAssetReferenceFragment on ContentAssetReference{
      id
      asset {
        id
        mimeType
        contentAssetReference {
          assetsId
        }
        fileSize
        originalFileName
        renderUrl
      }
  }
`)
